<div class="preload" *ngIf="show">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>
<router-outlet></router-outlet>